<div class="home" [@fadeInUp]>
  <!-- Hero Section -->
  <div class="container-fluid px-0">
    <section class="hero">
      <div class="hero-background">
        <!-- Display uploaded banner image if available, otherwise show default background -->
        <img *ngIf="bannerImageUrl" [src]="bannerImageUrl" alt="Banner image" class="img-fluid banner-image">
        <img *ngIf="!bannerImageUrl" src="./svg/background-home.jpg" alt="background image" class="img-fluid">
      </div>
      <!-- Floating Images -->
      <!-- <div class="floating-images">
        
        <div class="floating-image">
          <img src="./product/Pouch1ForPowder.svg" alt="Supplement Bottle 1">
        </div>
        <div class="floating-image">
          <img src="./product/Pouch2design-Front.svg" alt="Supplement Bottle 2">
        </div>
        <div class="floating-image">
          <img src="dr.png" alt="Doctor">
        </div>
      </div> -->

      <!-- <div class="hero-content">
        <div class="hero-subheader">{{ t('header1') }}</div>
        <h1 class="hero-title">
          {{ t('subHeader1') }}
          <span class="highlight">{{ t('subHeader2') }}</span>
        </h1>
      </div> -->

    </section>
  </div>

  <!-- Offer Banner -->
  <div *ngIf="offerImages.length > 0" class="offers-section">
    <div class="offer-carousel">
      <div class="carousel-container">
        <div class="carousel-track" [style.transform]="'translateX(-' + (currentOfferIndex * 100) + '%)'">
          <div class="carousel-slide" *ngFor="let offerUrl of offerImages; let i = index">
            <img [src]="offerUrl" [alt]="'Offer banner ' + (i + 1)" class="offer-banner-image">
          </div>
        </div>
        
        <!-- Navigation arrows -->
        <button class="carousel-nav carousel-prev" (click)="previousOffer()" *ngIf="offerImages.length > 1">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button class="carousel-nav carousel-next" (click)="nextOffer()" *ngIf="offerImages.length > 1">
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
      
      <!-- Carousel indicators -->
      <div class="carousel-indicators" *ngIf="offerImages.length > 1">
        <span *ngFor="let offer of offerImages; let i = index" 
              class="indicator" 
              [class.active]="i === currentOfferIndex" 
              (click)="goToOffer(i)">
        </span>
      </div>
    </div>
  </div>
  <app-offer-banner *ngIf="offerImages.length === 0"></app-offer-banner>

  <!-- Products Section -->
  <div class="container">
    <section class="products-section">
      <div class="section-content">
        <div class="section-intro">
          <p>{{ t('naturesAndHappiness') }}</p>
        </div>

        <!-- Desktop Product Cards Grid -->
        <div class="products-grid">
          <!-- Show skeleton loaders while loading -->
          <ng-container *ngIf="isLoadingProducts">
            <app-product-card-skeleton *ngFor="let item of [1,2,3,4]"></app-product-card-skeleton>
          </ng-container>
          
          <!-- Show actual products when loaded -->
          <ng-container *ngIf="!isLoadingProducts">
            <ng-container *ngFor="let product of products">
              <app-product-card *ngIf="product.isActive" [product]="product"></app-product-card>
            </ng-container>
          </ng-container>
        </div>



        <!-- Mobile Product Cards Grid -->
        <!-- <div class="mobile-products">
           <div *ngFor="let product of products" class="mobile-product">
             <div class="mobile-product-content" [style.background]="getGradientForProduct(product)">
               <div class="mobile-product-header">
                 <div class="mobile-product-info">
                   <h3>{{product.name}}</h3>
                   <p>{{product.description}}</p>
                   <p class="dosage">{{product.dosage}}</p>
                 </div>
                 <div class="mobile-product-badge">
                   {{product.quantity}}
                 </div>
               </div>
               
               <div class="mobile-product-image">
                 <img 
                   [src]="product.image" 
                   [alt]="product.name"
                 >
               </div>
               
               <div class="mobile-product-features">
                 <div *ngFor="let feature of product.features">
                   {{feature}}
                 </div>
               </div>
               
               
             </div>
           </div>
         </div> -->
      </div>
    </section>
  </div>

  <div class="container">
    <section class="video-section">
      <div class="video-content">
        <div class="video-title">
          <h2 class="video-title">{{ t('watchWhatOurCustomersSay') }}</h2>
        </div>

        <div class="row">
          <div class="col-12 col-md-8">
            <iframe src="https://www.youtube.com/embed/vbkfTEeitWA" title="#drpiyu big experience" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </div>
          <div class="col-12 col-md-4">

            <div class="video-text">
              <p>{{ t('videoSectionText1') }}</p>
              <p>{{ t('videoSectionText2') }}</p>
              <p>{{ t('videoSectionText3') }}</p>
              <p>{{ t('videoSectionText4') }}</p>
            </div>
          </div>
        </div>

      </div>
    </section>
  </div>

  <!-- Customer Experience Section -->
  <div class="container">
    <section class="reviews-section">
      <div class="section-content">
        <div class="reviews-title">
          <h2>
            {{ t('customerExperiences') }}
            <span class="block">{{ t('andFeedback') }}</span>
          </h2>
        </div>

        <div class="review-card" (mouseenter)="pauseAutoPlay()" (mouseleave)="resumeAutoPlay()">
          <div class="review-content">
            <div class="reviewer-avatar">
              <div class="avatar">{{ feedbacks[currentFeedbackIndex].avatar }}</div>
            </div>
            <div class="review-body">
              <p class="review-text">                
                {{ feedbacks[currentFeedbackIndex].text }}
              </p>
              <div class="review-footer">
                <div class="reviewer-info">
                  <h4>{{ feedbacks[currentFeedbackIndex].name }}</h4>
                  <p>{{ feedbacks[currentFeedbackIndex].location }}</p>
                </div>
                <div class="review-nav">
                  <button class="nav-btn" (click)="previousFeedback()">‹</button>
                  <button class="nav-btn" (click)="nextFeedback()">›</button>
                </div>
              </div>
            </div>
          </div>

          <!-- Carousel Indicators -->
          <div class="carousel-indicators">
            <span *ngFor="let feedback of feedbacks; let i = index" class="indicator"
              [class.active]="i === currentFeedbackIndex" (click)="goToFeedback(i)">
            </span>
          </div>
        </div>
      </div>
    </section>
  </div>

</div>
